/**
 * Map from section label (accordion heading) to work scope slug for region filtering.
 * Used to exclude inactive work scopes from the blank-workscope check.
 * Must match backend work scope slugs (e.g. block-wall, install-roofing).
 */
export const SECTION_LABEL_TO_WORK_SCOPE_SLUG: Record<string, string> = {
  "Tree, Exterior Debris & Heavy Equipment": "tree-work",
  "Roofing": "install-roofing",
  "Crawl Space": "m-and-g-crawl-space",
  "Muck & Gut": "muck-and-gut-interior",
  "Mold Remediation": "mold-remediation",
  "Rebuild Prep": "rebuild-prep",
  "Rough Carpentry": "rough-carpentry",
  "Electrical": "electrical-fixtures",
  "HVAC": "hvac-final",
  "Plumbing": "plumbing-fixtures",
  "Insulation Install": "insulation",
  "Drywall Hanging": "drywall-hanging",
  "Mud and Tape": "mud-and-tape",
  "Block Wall": "block-wall",
  "Rendering/Stucco": "stucco",
  "Bathroom Rebuild": "bathroom-rebuild",
  "Cabinet Install": "install-cabinets",
  "Interior Paint": "interior-paint",
  "Flooring Install": "flooring-install",
  "Install Interior Doors": "install-interior-doors",
  "Trim Install": "trim-install",
  "Exterior Door Install": "install-exterior-doors",
  "Driveway Repair": "repair-driveway",
  "Storm Shutters": "shutter-install",
  "Miscellaneous Goodwill": "misc",
}

/**
 * Flattened list of workscope status paths and section labels for the Overall Home Status
 * "blank workscopes" confirmation. Used when user sets Overall Status to Functionally Complete,
 * Complete, Materials Only Complete, or legacy 100%/Fully Complete. Assessment (Home Type & Repairability Info)
 * is excluded.
 */
export const WORKSCOPE_PATHS_FOR_OVERALL_STATUS_CHECK: { path: string; sectionLabel: string }[] = [
  { path: "home.treeDebrisInfo.treeWorkNeeded", sectionLabel: "Tree, Exterior Debris & Heavy Equipment" },
  { path: "home.treeDebrisInfo.exteriorDebrisRemovalNeeded", sectionLabel: "Tree, Exterior Debris & Heavy Equipment" },
  { path: "home.treeDebrisInfo.heavyEquipmentNeeded", sectionLabel: "Tree, Exterior Debris & Heavy Equipment" },
  { path: "home.roofingInfo.roofing", sectionLabel: "Roofing" },
  { path: "home.roofingInfo.roofTarpNeeded", sectionLabel: "Roofing" },
  { path: "home.crawlSpaceInfo.crawlSpaceMuck", sectionLabel: "Crawl Space" },
  { path: "home.crawlSpaceInfo.crawlSpaceInsulation", sectionLabel: "Crawl Space" },
  { path: "home.muckGutInfo.muckGutNeeded", sectionLabel: "Muck & Gut" },
  { path: "home.moldRemediationInfo.moldRemediation", sectionLabel: "Mold Remediation" },
  { path: "home.rebuildPrepInfo.rebuildPrep", sectionLabel: "Rebuild Prep" },
  { path: "home.roughCarpentryInfo.roughCarpentry", sectionLabel: "Rough Carpentry" },
  { path: "home.electricalInfo.electrical", sectionLabel: "Electrical" },
  { path: "home.electricalInfo.electricalRoughIn", sectionLabel: "Electrical" },
  { path: "home.hvacInfo.hvac", sectionLabel: "HVAC" },
  { path: "home.hvacInfo.mechanicalRoughIn", sectionLabel: "HVAC" },
  { path: "home.plumbingInfo.plumbing", sectionLabel: "Plumbing" },
  { path: "home.plumbingInfo.plumbingRoughIn", sectionLabel: "Plumbing" },
  { path: "home.insulationInstallInfo.insulationInstall", sectionLabel: "Insulation Install" },
  { path: "home.drywallHangingInfo.drywallHanging", sectionLabel: "Drywall Hanging" },
  { path: "home.mudAndTapeInfo.mudAndTape", sectionLabel: "Mud and Tape" },
  { path: "home.blockWallInfo.blockWallRepair", sectionLabel: "Block Wall" },
  { path: "home.stuccoInfo.stucco", sectionLabel: "Rendering/Stucco" },
  { path: "home.bathroomRebuildInfo.bathroomRebuild", sectionLabel: "Bathroom Rebuild" },
  { path: "home.cabinetInstallInfo.cabinetInstall", sectionLabel: "Cabinet Install" },
  { path: "home.cabinetInstallInfo.counterInstall", sectionLabel: "Cabinet Install" },
  { path: "home.cabinetInstallInfo.applianceInstall", sectionLabel: "Cabinet Install" },
  { path: "home.interiorPaintInfo.interiorPaint", sectionLabel: "Interior Paint" },
  { path: "home.flooringInstallInfo.flooringInstall", sectionLabel: "Flooring Install" },
  { path: "home.installInteriorDoorsInfo.installInteriorDoors", sectionLabel: "Install Interior Doors" },
  { path: "home.trimInstallInfo.trimInstall", sectionLabel: "Trim Install" },
  { path: "home.exteriorDoorInstallInfo.exteriorDoorInstall", sectionLabel: "Exterior Door Install" },
  { path: "home.drivewayRepair.drivewayRepair", sectionLabel: "Driveway Repair" },
  { path: "home.stormShutters.shutterInstall", sectionLabel: "Storm Shutters" },
  { path: "home.miscellaneousInfo.miscellaneous", sectionLabel: "Miscellaneous Goodwill" },
]
